export class Permissions {
  public static readonly ADMINISTRATIONS = 'ADMINISTRATIONS';
  public static readonly USERS = 'USERS';
  public static readonly IMPORT = 'IMPORT';
  public static readonly INVOICES = 'INVOICES';
  public static readonly CONTRACTS = 'CONTRACTS';
  public static readonly RELATIONS = 'RELATIONS';
  public static readonly RELATIONARTICLES = 'RELATIONARTICLES';
  public static readonly RELATIONDEVICES = 'RELATIONDEVICES';
  public static readonly ARTICLES = 'ARTICLES';
  public static readonly VEHICLES = 'VEHICLES';
  public static readonly OFFER_LEADS = 'OFFER_LEADS';
  public static readonly OFFER_QUOTATION = 'OFFER_QUOTATION';
  public static readonly PROSPECTS = 'PROSPECTS';
  public static readonly PURCHASES = 'PURCHASES';
  public static readonly STOCK = 'STOCK';
  public static readonly VEHICLEREGISTER = 'VEHICLEREGISTER';
  public static readonly BOOKKEEPING = 'BOOKKEEPING';
  public static readonly REMINDER = 'REMINDER';
  public static readonly FINANCEREPORT = 'FINANCE-REPORT';
  public static readonly WORK_ORDERS = 'WORK_ORDERS';
  public static readonly DEVICES = 'DEVICES';
  public static readonly SETTINGS = 'SETTINGS';
  public static readonly SETTINGS_GENERAL = 'SETTINGS_GENERAL';
  public static readonly SETTINGS_ADDRESS_TYPES = 'SETTINGS_ADDRESS_TYPES';
  public static readonly SETTINGS_COMMUNICATION_TYPES = 'SETTINGS_COMMUNICATION_TYPES';
  public static readonly SETTINGS_USERS = 'SETTINGS_USERS';
  public static readonly SETTINGS_VAT_RULES = 'SETTINGS_VAT_RULES';
  public static readonly SETTINGS_MANUFACTURERS = 'SETTINGS_MANUFACTURERS';
  public static readonly SETTINGS_DEVICES = 'SETTINGS_DEVICES';
  public static readonly SETTINGS_REPORTS = 'SETTINGS_REPORTS';
  public static readonly SETTINGS_SNELSTART = 'SETTINGS_SNELSTART';
}
